<script>
import { marked } from 'marked';
import Endpoints from './Endpoints.vue';

export default {
  name: 'ApiPageHeader',

  components: {
    Endpoints,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      marked,
    };
  },

  computed: {
    latestVersion() {
      return this.content.availableVersions[this.content.availableVersions.length - 1];
    },

    endpoints() {
      return this.content.endpoints;
    },
  },

  methods: {
    isSelected(version) {
      return (
        this.$route.params &&
        this.$route.params.version &&
        this.$route.params.version.replace('v', '') === version
      );
    },

    goToVersion(event) {
      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, version: `v${event.target.value}` },
      });
    },
  },
};
</script>

<template>
  <header class="api-reference-header">
    <div class="description column">
      <div class="title">
        <h1>{{ content.title }}</h1>

        <select @change="goToVersion($event)" aria-label="Versions">
          <option
            v-for="(version, i) in content.availableVersions"
            :key="i"
            :value="version"
            :selected="isSelected(version)"
          >
            v{{ version }}
            <template v-if="version === latestVersion"> (latest) </template>
          </option>
        </select>
      </div>

      <div class="text" v-html="marked.parse(content.description)" />
    </div>

    <div v-if="endpoints" class="endpoints column">
      <Endpoints :endpoints="endpoints" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
.api-reference-header {
  @include sections-wrapper;
  padding-bottom: $space-24;
  max-width: $page-width;

  @include tablet-small {
    padding-bottom: $space-40;
  }

  @include desktop-small {
    padding-top: $space-8;
    display: flex;
    justify-content: space-between;
  }

  .column {
    @include desktop-small {
      width: 50%;
    }
  }

  .endpoints {
    margin-top: $space-16;
    max-width: $code-block-width;

    @include tablet-small {
      margin-top: $space-24;
    }

    @include desktop-small {
      margin: 0 0 0 $space-56;
    }
  }

  .description {
    max-width: $code-block-width;

    .title {
      margin-bottom: $space-16;

      @include desktop-large {
        display: flex;
        align-items: center;
        justify-content: space-between;
        justify-content: flex-start;
      }

      h1 {
        margin: 0;
      }

      select {
        @include input-field-select;
        @include primary-text-regular;
        border: 1px solid $separator-color;
        width: max(9rem, 9 * 16px);
        min-height: 38px;
        padding: 0 $space-16;
        margin-top: $space-16;
        flex-shrink: 0;

        @include desktop-large {
          margin-top: 0;
          margin-left: $space-24;
        }
      }
    }

    .text {
      @include primary-text-regular;
      margin: 0;

      :deep(hr) {
        border: 0;
        border-bottom: 1px solid $separator-color;
        margin: $space-24 0;
      }

      :deep(pre) {
        @include caption-regular;

        code {
          @include inline-code;
        }
      }
    }
  }
}

.separator {
  border-bottom: 1px solid $separator-color;
  max-width: calc($page-width - $space-40);
}
</style>
